export default __webpack_public_path__ + "static/media/zumzi_telefon_aplicatie.3112caab.png";